export default "__VITE_ASSET__$hf7OkwT__";